import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { useRouter } from 'next/router'

import { Nav } from '@/components/generals/nav'
import { Footer } from '@/components/generals/footer'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    const { pathname } = useRouter()

    /* The flythrough owns the full viewport and swallows the scroll gesture, so
     * a footer in normal flow there would sit below the fold with no way to
     * reach it. On that page only, it overlays the bottom edge instead. */
    const isStage = pathname === '/'

    return (
        <div className='flex min-h-screen flex-col bg-stage'>
            <Nav />

            <main className='flex-1'>
                {children}
            </main>

            <Footer overlay={isStage} />
        </div>
    )
}
